// This middleware preloads a few queries that are otherwise being triggered multiple times
// during the initial page load.
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only run this on the server.
  // That way we make sure it only happens on the initial page load.
  if (import.meta.client) return

  const { authStatus } = useAuth()

  if (authStatus.value == AuthStatus.SignedIn) {
    // Prepopulate the cache
    await fetchCurrentUser()
  }

  // Fetch the current center
  const { fetch, currentCenter } = useCurrentCenter()
  await fetch()

  // In dev mode, redirect to the switch page if the current center is not found
  if (import.meta.dev && !currentCenter.value) {
    console.error('[preload middleware] current center not found')
    if (!to.path.includes('/switch')) {
      return navigateTo('/switch')
    }
  }

  // Preload the menus
  const { fetch: fetchMenus } = useCmsMenu('main')
  await fetchMenus()
})
